import axiosInstance from "services/AxiosInstance";
import { TFeatureFlagUserListResponse } from "types";

export const getUserFeatureFlagListService = async (userId?: string): Promise<TFeatureFlagUserListResponse> => {
  const response = await axiosInstance.get(`featureflags/user/${userId}`);
  return response.data;
};
